import { Check } from "lucide-react";
import { EXPERIENCE, POST_PURCHASE } from "@/data/content";
import { SectionHeading } from "./SectionHeading";

const Split = ({ id, data, kicker, reverse }) => (
  <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-16">
    <div className={reverse ? "lg:order-2" : ""}>
      <SectionHeading kicker={kicker} title={data.title} subtitle={data.lead} />
      <ul className="mt-8 space-y-4" data-testid={`${id}-points`}>
        {data.points.map((p) => (
          <li key={p} className="flex items-start gap-3">
            <span className="mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full bg-[#B12A2A]/15 text-[#B12A2A]">
              <Check className="h-4 w-4" strokeWidth={3} />
            </span>
            <span className="text-base leading-relaxed text-white/75">{p}</span>
          </li>
        ))}
      </ul>
    </div>
    <div className={`relative overflow-hidden rounded-md border border-white/10 ${reverse ? "lg:order-1" : ""}`}>
      <img src={data.image} alt={data.title} className="h-full max-h-[460px] w-full object-cover" />
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
    </div>
  </div>
);

export const Experience = () => (
  <section id="experience" className="border-t border-white/5 bg-black py-24">
    <div className="container mx-auto flex flex-col gap-24 px-4 sm:px-6 lg:px-8">
      <Split id="experience" data={EXPERIENCE} kicker="Мій досвід" />
      <Split id="post-purchase" data={POST_PURCHASE} kicker="Підтримка та безпека" reverse />
    </div>
  </section>
);
